export default __webpack_public_path__ + "assets/images/3cf1b585e7efa9380975d1f9f5523b5f.png";